var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListO(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.667.833c.92 0 1.666.747 1.666 1.667v15c0 .92-.746 1.667-1.666 1.667H3.333c-.92 0-1.666-.747-1.666-1.667v-15c0-.92.746-1.667 1.666-1.667h13.334zm0 1.667H3.333v15h13.334v-15zm-3.334 10.833c.46 0 .834.373.834.834 0 .46-.373.833-.834.833H6.667c-.46 0-.834-.373-.834-.833 0-.46.373-.834.834-.834h6.666zm0-4.166c.46 0 .834.373.834.833 0 .46-.373.833-.834.833H6.667c-.46 0-.834-.373-.834-.833 0-.46.373-.833.834-.833h6.666zm0-4.167c.46 0 .834.373.834.833 0 .46-.373.834-.834.834H6.667c-.46 0-.834-.373-.834-.834 0-.46.373-.833.834-.833h6.666z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListO);
export default __webpack_public_path__ + "static/media/list-o.d6cb98b7.svg";
export { ForwardRef as ReactComponent };